import { uid } from "./uid"

export const ruid = () => {
  const shift = 2n ** 63n // 9223372036854775808n or 2ˆ63 in postgresql
  const ruid = shift - BigInt(uid())
  return ruid.toString()
}
